import type { RepositoryIntelligenceCitation } from '@ashniva/types';

/** A piece of an answer: words, or a citation marker that opens the cited lines. */
export type AnswerSegment =
  | { kind: 'text'; text: string }
  | { kind: 'citation'; ref: string; citation: RepositoryIntelligenceCitation };

const MARKER = /\[(E\d{1,4})\]/g;

/**
 * An answer's text as plain-text pieces and citation markers (MASTER-SPEC §14.4). The text is never interpreted:
 * no Markdown, no HTML, no links — a `[E3]` that names one of the answer's citations becomes a button, and anything
 * else, including a marker with no citation behind it, stays text exactly as written.
 */
export function answerSegments(
  text: string,
  citations: readonly RepositoryIntelligenceCitation[],
): AnswerSegment[] {
  const byRef = new Map(citations.map((citation) => [citation.ref, citation]));
  const segments: AnswerSegment[] = [];
  let pending = '';
  let last = 0;
  for (const match of text.matchAll(MARKER)) {
    const ref = match[1] ?? '';
    const citation = byRef.get(ref);
    pending += text.slice(last, match.index);
    last = match.index + match[0].length;
    if (!citation) {
      pending += match[0];
      continue;
    }
    if (pending) {
      segments.push({ kind: 'text', text: pending });
      pending = '';
    }
    segments.push({ kind: 'citation', ref, citation });
  }
  pending += text.slice(last);
  if (pending) {
    segments.push({ kind: 'text', text: pending });
  }
  return segments;
}
